import { SARL } from "./sarl";
import { SARLU } from "./sarlu";
import { SAS } from "./sas";
import { SASU } from "./sasu";
import { ONG } from "./ong";
import { DOMICILIATION } from "./domiciliation";
import { DEPOT_MARQUE } from "./depot_marque";
import { ASSOCIATION } from "./association";
import { FONDATION } from "./fondation";
import { SCI } from "./sci";
import { CDI } from "./cdi";
import { CDD } from "./cdd";
import { INDIVIDUEL } from "./individuel";
export const TYPES_DEMANDE_CI = {
  SARL,
  SARLU,
  SAS,
  SASU,
  SCI,
  ONG,
  INDIVIDUEL,
  DOMICILIATION,
  DEPOT_MARQUE,
  ASSOCIATION,
  FONDATION,
  CDI,
  CDD,
};
